//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      isShow: false,
    };
  },

  computed: {
    ...mapState('common', ['errorNotification']),
  },

  watch: {
    errorNotification(value) {
      if (value) {
        this.isShow = true;
      }
    },
  },

  methods: {
    ...mapActions('common', ['setErrorNotification']),

    show(value) {
      if (!value) {
        this.setErrorNotification('');
      }
    },
    hasTranslation(category, key) {
      // Проверяем, существует ли перевод для данной строки
      const translated = this.$t(`${category}.${key}`);
      return translated !== `${category}.${key}`;
    },
  },
};
